// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shop-4"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 3C18.6569 3 20 4.34315 20 6V21H4V6C4 4.34315 5.34315 3 7 3H17Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 21H9V15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15V21Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 21H9V15C9 13.3431 10.3431 12 12 12C13.6569 12 15 13.3431 15 15V21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 8V6C4 4.34315 5.34315 3 7 3H9M4 8V21M4 8H9M4 8H3M4 21H3M4 21H20M20 8V21M20 8H15M20 8V6C20 4.34315 18.6569 3 17 3H15M20 8H21M20 21H21M9 8H15M9 8V3M15 8V3M9 3H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Shop4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shop-4',
    ref,
    icon: element,
  },
));

Shop4Icon.displayName = 'Shop4Icon';

export default Shop4Icon;
